export enum EBuildingType {
    Other = 1,
    Office = 2,
    Business = 3,
    Educational = 4,
    Residential = 5,
    Industrial = 6,
    Leisure = 7,
    Healthcare = 8,
}